export default {
  data () {
    return {
      loader: null
    }
  },
  methods: {
    showLoading () {
      this.loader = this.$loading.show({
        canCancel: false
      })
    },
    hideLoading () {
      this.loader.hide()
    }
  }
}
